var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#00A0F3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9978 18.5977C12.4689 18.5977 9.45459 19.154 9.45459 21.3796C9.45459 23.6059 12.4501 24.182 15.9978 24.182C19.5268 24.182 22.5411 23.6264 22.5411 21.4C22.5411 19.1737 19.5464 18.5977 15.9978 18.5977Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M15.998 16.4783C18.4019 16.4783 20.3279 14.5514 20.3279 12.1483C20.3279 9.74525 18.4019 7.81836 15.998 7.81836C13.5949 7.81836 11.668 9.74525 11.668 12.1483C11.668 14.5514 13.5949 16.4783 15.998 16.4783Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount);
export default __webpack_public_path__ + "static/media/Account.cdc78ab73eb8cb992e01c0713e5562c2.svg";
export { ForwardRef as ReactComponent };